/**
 * Resolve a list-row member avatar for Image source (custom URL or CDN avatarId).
 */

import type { ImageSourcePropType } from 'react-native';
import {
  isAvatarUrl,
  normalizeAvatarImageUri,
} from '../../create/helpers/createUi.helper';
import { getAvatarAsset } from '../../avatars/helpers/getAvatarAsset';
import { AVATAR_MOODS, normalizeDisplayAvatarId } from '../../avatars/types/avatar.types';

/**
 * Stack/list avatars: prefer Zporti `avatarId` (CDN) over profile `avatar` URL.
 */
export function getWorldCupMemberAvatarSource(
  avatarUrl: string | null | undefined,
  avatarId: string | null | undefined,
): ImageSourcePropType | null {
  const idTrimmed = avatarId?.trim();
  if (idTrimmed) {
    return getAvatarAsset(
      normalizeDisplayAvatarId(idTrimmed),
      AVATAR_MOODS.IDLE,
      true,
    );
  }

  const trimmedUrl = avatarUrl?.trim();
  if (trimmedUrl && isAvatarUrl(trimmedUrl)) {
    return { uri: normalizeAvatarImageUri(trimmedUrl) };
  }

  const legacyFromUrlField =
    trimmedUrl && !isAvatarUrl(trimmedUrl) ? trimmedUrl : null;
  return getAvatarAsset(
    normalizeDisplayAvatarId(legacyFromUrlField),
    AVATAR_MOODS.IDLE,
    true,
  );
}
